import { render, staticRenderFns } from "./BD.vue?vue&type=template&id=8a6fae64&scoped=true"
import script from "./BD.vue?vue&type=script&lang=js"
export * from "./BD.vue?vue&type=script&lang=js"
import style0 from "./BD.vue?vue&type=style&index=0&id=8a6fae64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fae64",
  null
  
)

export default component.exports